import 'twin.macro';
import React from 'react';
import { useDeleteEvaluation } from '@teetsh/app/src/containers/CarnetsDeNotes/queries/evaluations/useDeleteEvaluation';
import DeleteButton from '@teetsh/app/src/components/Buttons/DeleteButton';
import { TrashIcon as Trash } from '@heroicons/react/24/outline';
import { useSchoolGoTo } from '@teetsh/app/src/containers/App/useSchoolGoTo';
import { carnetUrls } from '../urls';
import SchoolyearButtonLink from '@teetsh/app/src/components/Buttons/SchoolyearButtonLink';
import { ArrowLeftIcon as ArrowLeft } from '@heroicons/react/24/outline';
import {
  AutoSaveStatus,
  AutoSaveStatusType,
} from '@teetsh/app/src/components/AutoSaveStatus';
import { CopyEvalButton } from '@teetsh/app/src/containers/CarnetsDeNotes/Evaluations/CopyEvalButton';
import { useTranslation } from 'react-i18next';
import { useCDNContext } from 'containers/CarnetsDeNotes/CarnetDeNotesContext';
import { useNavigate } from 'react-router-dom';
import { UndoRedo } from 'containers/CarnetsDeNotes/Evaluations/UndoRedo';

interface Props {
  carnetDeNotesId: string;
  evaluationId: string;
  status: AutoSaveStatusType;
  isGuest?: boolean;
}

export function Header(props: Props) {
  const { carnetDeNotesId, evaluationId, status, isGuest } = props;
  const { getEvaluationLink } = useCDNContext();
  const removeEval = useDeleteEvaluation(carnetDeNotesId);
  const { t } = useTranslation(['carnet', 'common']);
  const navigate = useNavigate();
  const goTo = useSchoolGoTo();
  return (
    <nav
      tw="flex justify-end space-x-2 bg-white border-b items-center px-4 py-2"
      aria-label="Global"
    >
      <div tw="border-r pr-2 mr-2">
        <UndoRedo
          minimal
          evaluationId={evaluationId}
          carnetDeNotesId={carnetDeNotesId}
        />
      </div>

      <div tw="lg:hidden mr-auto">
        <SchoolyearButtonLink
          minimal
          icon={ArrowLeft}
          to={carnetUrls.details(carnetDeNotesId)}
        >
          {t('common:buttons.back')}
        </SchoolyearButtonLink>
      </div>
      <AutoSaveStatus status={status} />
      {!isGuest && (
        <CopyEvalButton
          minimal
          evaluationId={evaluationId}
          carnetDeNotesId={carnetDeNotesId}
        />
      )}
      <DeleteButton
        onClick={() =>
          removeEval(evaluationId).then(() => {
            if (getEvaluationLink) {
              // Un peu crado de mettre string vide mais ça permet de naviguer ailleurs et ça fait le taf
              return navigate(getEvaluationLink(carnetDeNotesId, ''));
            }
            goTo(carnetUrls.evaluations(carnetDeNotesId));
          })
        }
        withConfirmation
        outlined
        popoverText={t('carnet:evaluationForm.deleteEvaluationWarning')}
        icon={Trash}
        minimal
        aria-label="Supprimer l'évaluation"
        iconSize="lg"
        small
      />
    </nav>
  );
}
